import { Form, Input, Button, Space, TableColumnType } from 'antd';
import { useState } from 'react';
import SearchForm, { SearchFormItem } from '@/components/SearchForm';
import TabsTable, { TabsTableRef } from '@/components/TabsTable';
import { useRef } from 'react';
import {
  TableCurrentDataSource,
  FilterValue,
  SorterResult,
  TablePaginationConfig,
} from 'antd/es/table/interface';
import dayjs from 'dayjs';
import { FORMAT_DATE, FORMAT_TIME } from '@/types/common';

// 临时类型定义，后续可根据实际API调整
interface ForbiddenWordItem {
  id: number;
  word: string;
  createTime: string;
  updateTime: string;
  creatorName?: string;
  status?: number;
}

const ForbiddenWordPage = () => {
  const [form] = Form.useForm<{
    word?: string;
    createTime?: string;
    creatorName?: string;
  }>();

  const tabsTableRef = useRef<TabsTableRef>(null);

  const searchFormItems: SearchFormItem[] = [
    {
      name: 'word',
      label: '违禁词',
      component: <Input placeholder="请输入违禁词" />,
    },
    {
      name: 'creatorName',
      label: '创建人',
      component: <Input placeholder="请输入创建人" />,
    },
  ];

  const columns: TableColumnType<ForbiddenWordItem>[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: '违禁词',
      dataIndex: 'word',
      key: 'word',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      render: (item: string) => (item ? dayjs(item).format(FORMAT_TIME) : '-'),
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      render: (item: string) => (item ? dayjs(item).format(FORMAT_TIME) : '-'),
    },
    {
      title: '创建人',
      dataIndex: 'creatorName',
      key: 'creatorName',
    },
    {
      title: '操作',
      key: 'action',
      width: 150,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small">
          <Button type="link" onClick={() => handleEdit(record)}>
            编辑
          </Button>
          <Button type="link" danger onClick={() => handleDelete(record)}>
            删除
          </Button>
        </Space>
      ),
    },
  ];

  const queryFn = async (page: number, pageSize: number) => {
    // TODO: 实现API调用逻辑
    return {
      total: 0,
      currentPage: page,
      pageSize,
      records: [],
    };
  };

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<unknown> | SorterResult<unknown>[],
    extra: TableCurrentDataSource<unknown>
  ) => {
    // TODO: 实现排序逻辑
  };

  const handleSearch = () => {
    tabsTableRef.current?.refresh();
  };

  const handleAdd = () => {
    // TODO: 实现新增功能
  };

  const handleEdit = (record: ForbiddenWordItem) => {
    // TODO: 实现编辑功能
  };

  const handleDelete = (record: ForbiddenWordItem) => {
    // TODO: 实现删除功能
  };

  return (
    <div>
      <SearchForm form={form} items={searchFormItems} onFinish={handleSearch} />
      <div style={{ marginTop: 16, textAlign: 'right' }}>
        <Button type="primary" onClick={handleAdd}>
          新增违禁词
        </Button>
      </div>
      <TabsTable
        ref={tabsTableRef}
        columns={columns}
        queryFn={queryFn}
        queryKey="forbiddenWord"
        rowKey="id"
        onTableChange={handleTableChange}
        pageSize={20}
      />
    </div>
  );
};

export default ForbiddenWordPage;
